let dmData = [
        {
            "Name of Organization": "Insight News",
            "Parent Organization": "McFarlane Media Interests",
            "Address": "1815 Bryant Ave N.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55411",
            "County": "Hennepin",
            "Main phone number": "612-588-1313",
            "Main fax number": "612-588-2031",
            "Organization email": "batalara@insightnews.com",
            "Organization website": "www.insightnwews.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Patricia Weaver",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "patricia@insightnews.com",
            "[contact_name]'s phone number": "612-588-1313",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Weekly",
            "Publication dates for online media": "",
            "Target audience": "African American",
            "Topics covered:": "Insight News is the journal for community news, business and the arts with a circulation of 35,000, distributed to Minneapolis, St. Paul and surrounding suburbs each week.",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities Metro Area",
            "Estimated circulation/audience size: ": "35000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Minnesota Spokesman ",
            "Parent Organization": "",
            "Address": "3744 4th Avenue South",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55409",
            "County": "Hennepin",
            "Main phone number": "612-827-4021",
            "Main fax number": "612-827-0577",
            "Organization email": "",
            "Organization website": "www.spokesman-recorder.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Tracey Williams-Dillard",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "twilliams@spokesman-recorder.com",
            "[contact_name]'s phone number": "612-827-4021",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Weekly",
            "Publication dates for online media": "",
            "Target audience": "African American",
            "Topics covered:": "News, entertainment, business, classified listings and notices, events, sports",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities Metro Area",
            "Estimated circulation/audience size: ": "45000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "African News Journal",
            "Parent Organization": "",
            "Address": "1821 University Ave. W.  Suite 319",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "612-735-8801",
            "Main fax number": "",
            "Organization email": "anjnews@gmail.com",
            "Organization website": "",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Basha Said",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "kadharelmi@yahoo.com",
            "[contact_name]'s phone number": "(612) 229-1421",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Mshale Newspaper",
            "Parent Organization": "",
            "Address": "P.O. Box 80071",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55408",
            "County": "Hennepin",
            "Main phone number": "612-454-5648",
            "Main fax number": "",
            "Organization email": "mshale@mshale.com",
            "Organization website": "www.mshale.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Tom Gitaa",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "tgitaa@mshale.com",
            "[contact_name]'s phone number": "612-454-5648",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "Daily",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "Community News, Immigration, Health, Sports & Lifestyle",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Minneapolis/St. Paul Metro, Rochester, St. Cloud",
            "Estimated circulation/audience size: ": "30,000 Print Circulation Monthly & Over 5,000 Visitors Online Daily",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "PepperSoup",
            "Parent Organization": "Russell Communications, Ltd",
            "Address": "6309 84TH Court North",
            "City": "Brooklyn Park",
            "State": "MN",
            "Zip Code": "55445",
            "County": "Hennepin",
            "Main phone number": "612-554-0134",
            "Main fax number": "",
            "Organization email": "info@peppersoup.org",
            "Organization website": "www.peppersoup.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Wynfred Russell",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "wynfred@umn.edu",
            "[contact_name]'s phone number": "612-554-0134",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "African American,African (Immigrant)",
            "Topics covered:": "Public health, infectious disease, tropical disease",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Minnesota",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "The AfricaPaper",
            "Parent Organization": "Africa Institute for InternatIonal Reporting (AIIR)",
            "Address": "Suite 200F, 2738 Winnetka Ave. N",
            "City": "New Hope",
            "State": "MN",
            "Zip Code": "55427",
            "County": "Hennepin",
            "Main phone number": "763-568-4335",
            "Main fax number": "",
            "Organization email": "info@theafricapaper.com",
            "Organization website": "www.theafricapaper.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Issa A. Mansaray",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "763-568-4335",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Online",
            "Publication dates for print media": "Bi-monthly",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "Professional Journalism",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Minnesota and Midwest",
            "Estimated circulation/audience size: ": "60000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Voices Magazine",
            "Parent Organization": "Voices LLC",
            "Address": "7691 Central Ave. NE",
            "City": "Fridley",
            "State": "MN",
            "Zip Code": "55432",
            "County": "Hennepin",
            "Main phone number": "763-200-5681",
            "Main fax number": "",
            "Organization email": "cdwamina@hotmail.com",
            "Organization website": "www.voicesmagazine.net",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Charles Dwamina",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "charles@celesvoices.com",
            "[contact_name]'s phone number": "952-381-7697",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Quarterly",
            "Publication dates for online media": "",
            "Target audience": "African American,African (Immigrant)",
            "Topics covered:": "Community Activities, Personal Success, Life Style, Fashion, Arts & culture, Food & Healthy Living, Immigration, Business",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Hennepin, Anoka, Wright, St. Cloud, Scott, Ramsey, Washington",
            "Estimated circulation/audience size: ": "5000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Ze Habesha",
            "Parent Organization": "Ethopian and American Heritage Society of Minnesota",
            "Address": "1821 University Ave. W. Suite 106",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "612-226-8326",
            "Main fax number": "",
            "Organization email": "info@zehabesha.com",
            "Organization website": "www.zehabesha.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Henok A. Degfu",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "henocka2001@yahoo.com",
            "[contact_name]'s phone number": "(612) 226-8326",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "Community news, health, economy, international and local affairs, sports, legal advise",
            "Please list the languages your service offers:": "Amharic",
            "Please outline your coverage area (are of MN you serve):": "St. Clould, Rochester, Torthington, Twin cities Metro Area",
            "Estimated circulation/audience size: ": "10000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Aninishibeebeg Today",
            "Parent Organization": "",
            "Address": "P.O. Box 418",
            "City": "White Earth",
            "State": "MN",
            "Zip Code": "56591",
            "County": "Becker",
            "Main phone number": "218-983-3285",
            "Main fax number": "",
            "Organization email": "today@whiteearth-nsn.gov",
            "Organization website": "www.whiteearth.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Gary W. Padrta",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "today@whiteearth-nsn.gov",
            "[contact_name]'s phone number": "218-983-3285",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "American Indian",
            "Topics covered:": "American Indian issues",
            "Please list the languages your service offers:": "Mostly English with some Ojibwe",
            "Please outline your coverage area (are of MN you serve):": "White Earth Reservation in northwest Minnesota",
            "Estimated circulation/audience size: ": "13500",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Hiiraan Online",
            "Parent Organization": "",
            "Address": "",
            "City": "",
            "State": "",
            "Zip Code": "",
            "County": "",
            "Main phone number": "",
            "Main fax number": "",
            "Organization email": "webmaster@hiiraan.com",
            "Organization website": "www.hiiraan.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Bois Forte News",
            "Parent Organization": "",
            "Address": "5344 Lakeshore Drive",
            "City": "Nett Lake",
            "State": "MN",
            "Zip Code": "55772",
            "County": "Koochiching",
            "Main phone number": "218-757-3261",
            "Main fax number": "",
            "Organization email": "",
            "Organization website": "www.boisforte.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Louise Isham",
            "[contact_name]'s position": "Senior Executive Coordinator",
            "[contact_name]'s email": "lisham@boisforte-nsn.gov",
            "[contact_name]'s phone number": "218-404-6545",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "American Indian",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "DeBahJiMon",
            "Parent Organization": "",
            "Address": "190 Sialstar Drive NW",
            "City": "Cass lake",
            "State": "MN",
            "Zip Code": "56633",
            "County": "Hubbard",
            "Main phone number": "218-335-8225",
            "Main fax number": "218-335-8390",
            "Organization email": "debahjimon@llojibwe.org",
            "Organization website": "www.llojibwe.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Chris Haugene",
            "[contact_name]'s position": "Managing Editor",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Star White",
            "[contact_name_2]'s position": "Graphic Designer",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "American Indian",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Red Lake Nation News",
            "Parent Organization": "",
            "Address": "14748 Little Rock Trail",
            "City": "Redby",
            "State": "MN",
            "Zip Code": "56670",
            "County": "Beltrami",
            "Main phone number": "218-679-5995",
            "Main fax number": "",
            "Organization email": "",
            "Organization website": "www.redlakenationnews.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Michael Barrett",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "mbarrett@redlakenationnews.com",
            "[contact_name]'s phone number": "218-679-5995",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Online",
            "Publication dates for print media": "Daily",
            "Publication dates for online media": "",
            "Target audience": "American Indian",
            "Topics covered:": "Native American news and informationsource of the Red Lake IndianReservation and the surroundingNative American communities in Minnesota.",
            "Please list the languages your service offers:": "Native American and all others, English and Ojibwe",
            "Please outline your coverage area (are of MN you serve):": "Northern Minnesota, primarily, as well as Nation-wide and Canada",
            "Estimated circulation/audience size: ": "10 million+",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "The Circle Corporation",
            "Parent Organization": "",
            "Address": "3045 Bloomington Ave, #7506",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55407",
            "County": "Hennepin",
            "Main phone number": "612-722-3686",
            "Main fax number": "612-722-3773",
            "Organization email": "thecirclenews@gmail.com",
            "Organization website": "www.thecirclenews.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Cat Whipple",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "thecirclenews@gmail.com",
            "[contact_name]'s phone number": "612-722-3686",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "American Indian",
            "Topics covered:": "Native American (American Indian) issues, arts, culture, history, and commentary.",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities metro and all reservations in Minnesota.",
            "Estimated circulation/audience size: ": "45000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Fond du Lac News /  Nahgahchiwanong  Dibahjimowinnan",
            "Parent Organization": "",
            "Address": "1720 Big Lake Rd.",
            "City": "Cloquet",
            "State": "MN",
            "Zip Code": "55720",
            "County": "Carlton",
            "Main phone number": "218-878-2682",
            "Main fax number": "218-878-8180",
            "Organization email": "",
            "Organization website": "www.fdlrez.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Zachary Dunaiski",
            "[contact_name]'s position": "Editor",
            "[contact_name]'s email": "zacharydunaiski@fdlrez.com",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "American Indian",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "China Insight",
            "Parent Organization": "",
            "Address": "750 Mainstreet, #230",
            "City": "Hopkins",
            "State": "MN",
            "Zip Code": "55343",
            "County": "Hennepin",
            "Main phone number": "612-723-4872",
            "Main fax number": "",
            "Organization email": "ghugh@chinainsight.info",
            "Organization website": "www.chinainsight.info",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Gregory Hugh",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "ghugh@chinainsight.info",
            "[contact_name]'s phone number": "612-723-4872",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "Asian",
            "Topics covered:": "U.S. - China History, culture,  business understanding",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Minnesota",
            "Estimated circulation/audience size: ": "3000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "TCB Marketing/Insight News",
            "Parent Organization": "",
            "Address": "W11052 457th Avenue",
            "City": "Prescott",
            "State": "WI",
            "Zip Code": "54021",
            "County": "Out of State",
            "Main phone number": "651-304-2103",
            "Main fax number": "",
            "Organization email": "tcbmarketing@gmail.com",
            "Organization website": "www.tcbmarketing.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Steve Wetzler",
            "[contact_name]'s position": "Editor/Owner",
            "[contact_name]'s email": "tcbmarketing@gmail.com",
            "[contact_name]'s phone number": "651-304-2104",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Weekly",
            "Publication dates for online media": "",
            "Target audience": "African American",
            "Topics covered:": "Insight News is a Metropolitan and suburban based weekly newspaper with a circulation of 35,000 in Minneapolis, St. Paul, and the surrounding suburban area. Distributed free of cost, and provides information, instruction, and inspiration in a user-friendly, culturally relevant way for African American readers",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities",
            "Estimated circulation/audience size: ": "35000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "TCB Marketing/Minnesota Spokesman Recorder",
            "Parent Organization": "",
            "Address": "W11052 457th Avenue",
            "City": "Prescott",
            "State": "WI",
            "Zip Code": "54021",
            "County": "Out of State",
            "Main phone number": "651-304-2102",
            "Main fax number": "",
            "Organization email": "tcbmarketing@gmail.com",
            "Organization website": "www.tcbmarketing.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Steve Wetzler",
            "[contact_name]'s position": "Editor/Owner",
            "[contact_name]'s email": "tcbmarketing@gmail.com",
            "[contact_name]'s phone number": "651-304-2103",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Weekly",
            "Publication dates for online media": "",
            "Target audience": "African American",
            "Topics covered:": "",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities",
            "Estimated circulation/audience size: ": "10000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "TCB Marketing/Vida Y Sabor/LaPrensa",
            "Parent Organization": "",
            "Address": "W11052 457th Avenue",
            "City": "Prescott",
            "State": "WI",
            "Zip Code": "54021",
            "County": "Out of State",
            "Main phone number": "651-304-2104",
            "Main fax number": "",
            "Organization email": "tcbmarketing@gmail.com",
            "Organization website": "www.tcbmarketing.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Steve Wetzler",
            "[contact_name]'s position": "Editor/Owner",
            "[contact_name]'s email": "tcbmarketing@gmail.com",
            "[contact_name]'s phone number": "651-304-2105",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Weekly",
            "Publication dates for online media": "",
            "Target audience": "Latino/Latinx",
            "Topics covered:": "La Prensa and Vida Y Sabor are two individual publications that combined into one a few years ago and cover issues key to the Latino community and the community at large through reliable, analytical content and an innovative, bilingual approach.",
            "Please list the languages your service offers:": "Spanish",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities",
            "Estimated circulation/audience size: ": "10000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "TCB Marketing/African News Journal",
            "Parent Organization": "",
            "Address": "W11052 457th Avenue",
            "City": "Prescott",
            "State": "WI",
            "Zip Code": "54021",
            "County": "Out of State",
            "Main phone number": "651-304-2105",
            "Main fax number": "",
            "Organization email": "tcbmarketing@gmail.com",
            "Organization website": "www.tcbmarketing.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Steve Wetzler",
            "[contact_name]'s position": "Editor/Owner",
            "[contact_name]'s email": "tcbmarketing@gmail.com",
            "[contact_name]'s phone number": "651-304-2106",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African American,African (Immigrant)",
            "Topics covered:": "The African News Journal is a monthly publication serving over 13 African communities with a special emphasis on the Somali community. Published by MediaOne, they printed their first copy in August of 2005.  The African News Journal is distributed to over 180 locations across the Twin Cities and can be found at major libraries, bookstores, and community centers",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities",
            "Estimated circulation/audience size: ": "10, 000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Hmong Today",
            "Parent Organization": "Zoom Creatives",
            "Address": "2366 West 7th Street",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55116",
            "County": "Ramsey",
            "Main phone number": "651-489-0021",
            "Main fax number": "651-489-0054",
            "Organization email": "hmongtoday@gmail.com",
            "Organization website": "www.hmongtoday.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Sang Moua",
            "[contact_name]'s position": "Publisher",
            "[contact_name]'s email": "hmongtoday1@gmail.com",
            "[contact_name]'s phone number": "651-206-0708",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "Asian",
            "Topics covered:": "News and society",
            "Please list the languages your service offers:": "Hmong / English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities",
            "Estimated circulation/audience size: ": "10000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Korean Quarterly",
            "Parent Organization": "",
            "Address": "P.O. Box 6789",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55106",
            "County": "Ramsey",
            "Main phone number": "651-398-2325",
            "Main fax number": "",
            "Organization email": "koreanquarterly@gmail.com",
            "Organization website": "www.koreanquarterly.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Martha Vickery",
            "[contact_name]'s position": "Managing Editor",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "651-398-2325",
            "Second Contact name": "Stephen Wunrow",
            "[contact_name_2]'s position": "Publisher",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Quarterly",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "Culture, politics, peace, justice and identity issues, food, local, national and international news, book/film/drama/theater reviews, etc.",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cites, statewide, upper midwest, nationally",
            "Estimated circulation/audience size: ": "23000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Mille Lacs band of Ojibwe-Inaajimowin",
            "Parent Organization": "",
            "Address": "8009 34th Ave S",
            "City": "Bloomington",
            "State": "MN",
            "Zip Code": "55425",
            "County": "Hennepin",
            "Main phone number": "952-851-7262",
            "Main fax number": "952-851-1610",
            "Organization email": "",
            "Organization website": "www.millelacsband.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Owen Truesdell",
            "[contact_name]'s position": "Consultant",
            "[contact_name]'s email": "otruesdell@tunheim.com",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "American Indian",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Zerkalo, Inc.",
            "Parent Organization": "MidwestRTV, LLC.",
            "Address": "8 Nathan Lane N",
            "City": "Plymouth",
            "State": "MN",
            "Zip Code": "55441",
            "County": "Hennepin",
            "Main phone number": "763-545-1600",
            "Main fax number": "763-545-1602",
            "Organization email": "info@zerkalomn.com",
            "Organization website": "www.zerkalomn.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Leo Grichener",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "zerkaloleo@gmail.com",
            "[contact_name]'s phone number": "612-229-1600",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "European",
            "Topics covered:": "Advertising, Local, Nation and International news, Author Articles, Digest",
            "Please list the languages your service offers:": "Russian",
            "Please outline your coverage area (are of MN you serve):": "Statewide",
            "Estimated circulation/audience size: ": "6500",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Asian American Press",
            "Parent Organization": "",
            "Address": "7124 90th Avenue N",
            "City": "Brooklyn Park",
            "State": "MN",
            "Zip Code": "55445",
            "County": "Hennepin",
            "Main phone number": "651-755-6864",
            "Main fax number": "651-224-7032",
            "Organization email": "aanews@aapress.com",
            "Organization website": "www.aapress.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Nghi Huynh",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "nghi@aapress.com",
            "[contact_name]'s phone number": "651-755-6864",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Asian",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Twin Cities Gay Scene",
            "Parent Organization": "My Scene City, LLC",
            "Address": "6412 Colfax Ave. N.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55430",
            "County": "Hennepin",
            "Main phone number": "612-239-4410",
            "Main fax number": "",
            "Organization email": "contact@twincitiesgayscene.com",
            "Organization website": "www.TwinCitiesGayScene.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "David Birchard",
            "[contact_name]'s position": "Owner / Publisher",
            "[contact_name]'s email": "DavidBirchard@twincitiesgayscene.com",
            "[contact_name]'s phone number": "612-239-4410",
            "Second Contact name": "Cory Weissman",
            "[contact_name_2]'s position": "Owner / Publisher",
            "[contact_name_2]'s email": "CoryWeissman@twincitiesgayscene.com",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Online",
            "Publication dates for print media": "Bi-weekly",
            "Publication dates for online media": "",
            "Target audience": "LGBTQIA",
            "Topics covered:": "",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities Metro",
            "Estimated circulation/audience size: ": "50000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Latino Communication Network, LLC",
            "Parent Organization": "NewPublica, LLC",
            "Address": "2909 Bryant Ave. S, Suite 301",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55408",
            "County": "Hennepin",
            "Main phone number": "612-729-5900",
            "Main fax number": "612-729-5999",
            "Organization email": "info@newpublica.com",
            "Organization website": "",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Sandra Rodriguez",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "sandra@newpublica.com",
            "[contact_name]'s phone number": "612-276-7029",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print",
            "Publication dates for print media": "Weekly",
            "Publication dates for online media": "",
            "Target audience": "Latino/Latinx",
            "Topics covered:": "National, Local and Entertainment news",
            "Please list the languages your service offers:": "Spanish",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities Metro",
            "Estimated circulation/audience size: ": "10000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "MLatino Media",
            "Parent Organization": "",
            "Address": "P.O. Box 580752",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55458",
            "County": "Hennepin",
            "Main phone number": "651-335-1710",
            "Main fax number": "",
            "Organization email": "elmndehoy@gmail.com",
            "Organization website": "www.elminnesotadehoy.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Gustavo Mancilla",
            "[contact_name]'s position": "General Manager",
            "[contact_name]'s email": "gusmancilla@mlatinomedia.com",
            "[contact_name]'s phone number": "651-335-1710",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "Daily",
            "Publication dates for online media": "",
            "Target audience": "Latino/Latinx",
            "Topics covered:": "online as El Minnesota de Hoy, also with multicultural media placement capabilities  as MLatino Media.",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "La Matraca News",
            "Parent Organization": "",
            "Address": "3060 Bloomington Ave",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55407",
            "County": "Hennepin",
            "Main phone number": "612-825-1057",
            "Main fax number": "612-825-2408",
            "Organization email": "fabiola@lamatracanews.com",
            "Organization website": "www.lamatracamagazine.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Fabiola Gomez",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "fabiola@lamatracanews.com",
            "[contact_name]'s phone number": "612-825-2408",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Weekly",
            "Publication dates for online media": "",
            "Target audience": "Latino/Latinx",
            "Topics covered:": "Local News, Inmigration, Technology, Classified, Cook, Events, Health, Entertaiment, Sports.",
            "Please list the languages your service offers:": "Spanish/English",
            "Please outline your coverage area (are of MN you serve):": "We got 225 of distribution all over Minnesota",
            "Estimated circulation/audience size: ": "10000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Minnesota Times",
            "Parent Organization": "",
            "Address": "P O Box 46155",
            "City": "Plymouth",
            "State": "MN",
            "Zip Code": "55446",
            "County": "Hennepin",
            "Main phone number": "952-688-2848",
            "Main fax number": "952-922-9998",
            "Organization email": "contactMNTimes@gmail.com",
            "Organization website": "www.mntimes.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Linda Li  Editor",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Asian",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "La Voz Latina",
            "Parent Organization": "St. Paul Publishing Co.",
            "Address": "1643 S. Robert St., Suite 60B",
            "City": "West St. Paul",
            "State": "MN",
            "Zip Code": "55118",
            "County": "Ramsey",
            "Main phone number": "651-457-1177",
            "Main fax number": "",
            "Organization email": "tim@stpaulpublishing.com",
            "Organization website": "www.stpaulpublishing.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Tim Spitzack",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "tim@stpaulpublishing.com",
            "[contact_name]'s phone number": "651-457-1177",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "Latino/Latinx",
            "Topics covered:": "News and information about the Latino audience of St. Paul and Minneapolis",
            "Please list the languages your service offers:": "Spanish/Latino/Latinx",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities Metro",
            "Estimated circulation/audience size: ": "8500",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "TCB Marketing/Vida Y Sabor/LaPrensa",
            "Parent Organization": "",
            "Address": "W11052 457th Avenue",
            "City": "Prescott",
            "State": "WI",
            "Zip Code": "54021",
            "County": "Out of State",
            "Main phone number": "651-304-2102",
            "Main fax number": "612-729-5999",
            "Organization email": "tcbmarketing@gmail.com",
            "Organization website": "www.tcbmarketing.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Steve Wetzler",
            "[contact_name]'s position": "Editor/Owner",
            "[contact_name]'s email": "tcbmarketing@gmail.com",
            "[contact_name]'s phone number": "651 304-2102",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Weekly",
            "Publication dates for online media": "",
            "Target audience": "Latino/Latinx",
            "Topics covered:": "Local News",
            "Please list the languages your service offers:": "Hispanic",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities",
            "Estimated circulation/audience size: ": "10000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Latino American Today",
            "Parent Organization": "Aguilar Productions",
            "Address": "204 Emerson Avenue E.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55118",
            "County": "Ramsey",
            "Main phone number": "651-665-0633",
            "Main fax number": "",
            "Organization email": "aguilarproductions@msn.com",
            "Organization website": "www.latinoamericantoday.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Richard Aguilar",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "aguilarproductions@msn.com",
            "[contact_name]'s phone number": "651-276-6985",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "Latino/Latinx",
            "Topics covered:": "Education, Health and Fitness, Business, Community, Faith and Leadership, Outdoors Minnesota,",
            "Please list the languages your service offers:": "Bilingual - Spanish and English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities Metro Area",
            "Estimated circulation/audience size: ": "10000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "La Voz Latina",
            "Parent Organization": "St. Paul Publishing Co.",
            "Address": "1643 S. Robert St., Suite 60B",
            "City": "West St. Paul",
            "State": "MN",
            "Zip Code": "55118",
            "County": "Ramsey",
            "Main phone number": "651-457-1177",
            "Main fax number": "",
            "Organization email": "tim@stpaulpublishing.com",
            "Organization website": "www.stpaulpublishing.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Tim Spitzack",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "tim@stpaulpublishing.com",
            "[contact_name]'s phone number": "651-457-1177",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "Latino/Latinx",
            "Topics covered:": "News and information about the Latino audience of St. Paul and Minneapolis",
            "Please list the languages your service offers:": "Spanish",
            "Please outline your coverage area (are of MN you serve):": "St. Paul and Minneapolis",
            "Estimated circulation/audience size: ": "8500",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Greening Frogtown Newspaper",
            "Parent Organization": "Greening Frogtown Newspaper",
            "Address": "843 Van Buren Avenue",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "651-757-7479",
            "Main fax number": "",
            "Organization email": "apbschmitz@gmail.com",
            "Organization website": "www.greeningfrogtown.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Tony Schmitz",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "apbschmitz@gmail.com",
            "[contact_name]'s phone number": "651-757-7479",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print",
            "Publication dates for print media": "Bi-monthly",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "Neighborhood news that emphasizes efforts to make Frogtown a better place to live.",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Frogtown neighborhood of St. Paul: University Ave to Pierce Butler, 35E to Lexington.",
            "Estimated circulation/audience size: ": "15000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Lavender Magazine",
            "Parent Organization": "Lavender Media, Inc.",
            "Address": "7701 York Ave S  Suite 225",
            "City": "Edina",
            "State": "MN",
            "Zip Code": "55435",
            "County": "Hennepin",
            "Main phone number": "612-436-4660",
            "Main fax number": "",
            "Organization email": "info@lavendermagazine.com",
            "Organization website": "www.lavendermagazine.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Chris Tarbox",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "chris@lavendermagazine.com",
            "[contact_name]'s phone number": "612-436-4660",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Bi-weekly",
            "Publication dates for online media": "",
            "Target audience": "LGBTQIA",
            "Topics covered:": "GLBT Community arts, culture, business, health and dining.",
            "Please list the languages your service offers:": "Web magazine can be read 12 languages: English, Spanish, French, German, Dutch, Italian, Portuguese, Russian, Chinese, Korean, Czech & Greek.",
            "Please outline your coverage area (are of MN you serve):": "MN and Western Wisc.",
            "Estimated circulation/audience size: ": "263000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Latino Communication Network",
            "Parent Organization": "",
            "Address": "2909 Bryant Ave.S. Suite 202",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55408",
            "County": "Hennepin",
            "Main phone number": "612-729-5900",
            "Main fax number": "612-729-5999",
            "Organization email": "marian@lcnmedia.com",
            "Organization website": "www.lcnmedia.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Sandra Rodriguez",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "sandra@newpublica.com",
            "[contact_name]'s phone number": "612-276-7029",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Weekly",
            "Publication dates for online media": "",
            "Target audience": "Latino/Latinx",
            "Topics covered:": "Entertainment, National and Local news",
            "Please list the languages your service offers:": "Spanish",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities",
            "Estimated circulation/audience size: ": "10000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Midway Como Monitor",
            "Parent Organization": "Midway Como Monitor",
            "Address": "720 Hague Ave, Apt #4",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "651-489-9053",
            "Main fax number": "",
            "Organization email": "lynns@bitstream.net",
            "Organization website": "www.monitorsaintpaul.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Lynn M Santacaterina",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "lynns@bitstream.net",
            "[contact_name]'s phone number": "651-489-9053",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "The Monitor is a 44-year-old monthly neighborhood newspaper with an estimated reach of over 50,000 residents in St. Paul’s Midway, Como and Merriam Park neighborhoods. With a circulation of 21,000, the Monitor offers comprehensive delivery to 16,000 homes and businesses and an additional circulation of 5,000 at high-traffic business, church and school drop-off points. The Monitor features stories on people, events, news, and resources in and around the delivery areas.",
            "Please list the languages your service offers:": "Latino/Latinx, People with disabilities, GLBTQ, European, Asian, American Indian, African Born, African American",
            "Please outline your coverage area (are of MN you serve):": "Hamline-Midway, Como, Merriam Park, and Como neighborhoods of St. Paul.",
            "Estimated circulation/audience size: ": "21, 000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "One Nation News",
            "Parent Organization": "Black Heart, Inc.",
            "Address": "1614 Harmon Place  Suite 203",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55403",
            "County": "Hennepin",
            "Main phone number": "763-205-6751",
            "Main fax number": "",
            "Organization email": "info@onenationnews.com",
            "Organization website": "www.onenationnews.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Jae Bryson",
            "[contact_name]'s position": "Publisher and CEO",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "Weekly",
            "Target audience": "Multicultural",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "10000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Sahan Journal",
            "Parent Organization": "",
            "Address": "370 Wabasha St. N.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55102",
            "County": "Ramsey",
            "Main phone number": "651-290-1051",
            "Main fax number": "",
            "Organization email": "editor@sahanjournal.com",
            "Organization website": "www.sahanjournal.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Mukhtar Ibrahim",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "editor@sahanjournal.com",
            "[contact_name]'s phone number": "651-290-1051",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Online",
            "Publication dates for print media": "Daily",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "Sahan Journal offers serious journalism about and for Minnesota’s immigrant and refugee communities.",
            "Please list the languages your service offers:": "Sahan Journal is published in English, serving Minnesota’s immigrants and refugees with a focus on coverage of the three largest immigrant groups: Latino, Somali, and Hmong.",
            "Please outline your coverage area (are of MN you serve):": "20,000 unique visitors per month.",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "The American Jewish World",
            "Parent Organization": "",
            "Address": "4820 Minnetonka Blvd.  Suite 104",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55416",
            "County": "Hennepin",
            "Main phone number": "952-259-5234",
            "Main fax number": "952-920-6205",
            "Organization email": "editor@ajwnews.com",
            "Organization website": "www.ajwnews.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Mordecai Specktor",
            "[contact_name]'s position": "Editor and Publisher",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Access Press, Ltd",
            "Parent Organization": "Access Press",
            "Address": "161 St. Anthony Blvd Ste 910",
            "City": "Saint Paul",
            "State": "MN",
            "Zip Code": "55103",
            "County": "Ramsey",
            "Main phone number": "651-644-2133",
            "Main fax number": "651-644-2136",
            "Organization email": "access@accesspress.org",
            "Organization website": "www.accesspress.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Dawn Frederick",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "dawn@accesspress.org",
            "[contact_name]'s phone number": "651-644-2133",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "People with disabilities",
            "Topics covered:": "The voice of the disabled and senior communities in the state of Minnesota",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Minnesota",
            "Estimated circulation/audience size: ": "12000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Somali American Newspaper",
            "Parent Organization": "",
            "Address": "2143 Lowry avenue N, suite B",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55411",
            "County": "Hennepin",
            "Main phone number": "612-216-2415",
            "Main fax number": "612-259-8027",
            "Organization email": "admin@thesomaliamerican.com",
            "Organization website": "www.thesomaliamerican.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Warsame Guled",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "wiguled@gmail.com",
            "[contact_name]'s phone number": "919-841-3359",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "Issues concerning the Somali community in MN",
            "Please list the languages your service offers:": "English / Somali",
            "Please outline your coverage area (are of MN you serve):": "Minneapolis",
            "Estimated circulation/audience size: ": "10, 000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Tusmo Times",
            "Parent Organization": "",
            "Address": "",
            "City": "",
            "State": "",
            "Zip Code": "",
            "County": "",
            "Main phone number": "",
            "Main fax number": "",
            "Organization email": "abdirahmanmukhtar@gmail.com",
            "Organization website": "www.tusmotimes.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Abdirahman Mukhtar",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "abdirahmanmukhtar@gmail.com",
            "[contact_name]'s phone number": "(612) 987-6269",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "Monthly",
            "Publication dates for online media": "Daily",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "Topics regarding the Somali American and East African Community in Minnesota",
            "Please list the languages your service offers:": "Somali, English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities, Metro Area and most cities that the Somali community leaves in Minnesota. Both local and national on our website and online content.",
            "Estimated circulation/audience size: ": "10,000 printing circulation, 17 - 20 thousand online.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "WREY El Rey",
            "Parent Organization": "",
            "Address": "149 Thompson ave E #201",
            "City": "West St.Paul",
            "State": "MN",
            "Zip Code": "55118",
            "County": "Ramsey",
            "Main phone number": "651-227-6318",
            "Main fax number": "651-227-6306",
            "Organization email": "felicia@elrey949fm.com",
            "Organization website": "www.elrey949fm.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Felicia Ortega",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "Felicia@elrey949fm.com",
            "[contact_name]'s phone number": "651-227-6318",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "WREY 630am",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Latino/Latinx",
            "Topics covered:": "local events, local news and music",
            "Please list the languages your service offers:": "Spanish",
            "Please outline your coverage area (are of MN you serve):": "Twin cities and surrounding cities",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "KMOJ Radio 89.9FM",
            "Parent Organization": "Center for Communication and Development",
            "Address": "2123 W. Broadway Suite 200",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55422",
            "County": "Hennepin",
            "Main phone number": "612-377-0594",
            "Main fax number": "612-521-9006",
            "Organization email": "info@kmojfm.com",
            "Organization website": "www.kmojfm.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "GM Freddie Bell",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "freddiebell@kmojfm.com",
            "[contact_name]'s phone number": "612-377-0594",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "KMOJ 89.9FM",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "Health, Education, Broadcast Training, Community Empowerment, Hiring Fairs, Issues the within Communities of color",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities Metro and beyond, 25 in Wisconsin, St.Cloud at night, Lakeville, Lake City",
            "Estimated circulation/audience size: ": "250,000 unduplicated Listeners",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "KMSU - The Maverick 89.7 FM",
            "Parent Organization": "Minnesota State University Mankato",
            "Address": "1536 Warren Street",
            "City": "Mankato",
            "State": "MN",
            "Zip Code": "56001",
            "County": "Blue Earth",
            "Main phone number": "507-389-5678",
            "Main fax number": "507-389-1705",
            "Organization email": "james.gullickson@mnsu.edu",
            "Organization website": "www.mnsu.edu/kmsufm/index.html",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Dwayne Megaw",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "dwayne.megaw@mnsu.edu",
            "[contact_name]'s phone number": "507-389-5678",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "KMSU-FM 89.7 FM",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "A wide range of shows are presented for various cultures, including: African World Beat, Latino Affairs, and other International Cultures",
            "Please list the languages your service offers:": "English except Saturdays 12p-6p, where programming is Spanish-Speaking",
            "Please outline your coverage area (are of MN you serve):": "Southern Minnesota",
            "Estimated circulation/audience size: ": "15000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Asian American Broadcasting, LLC",
            "Parent Organization": "",
            "Address": "1088 Payne Ave.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55130",
            "County": "Ramsey",
            "Main phone number": "612-810-6412",
            "Main fax number": "",
            "Organization email": "kongsuex@yahoo.com",
            "Organization website": "www.hmongradioam690.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Kongsue Xiong",
            "[contact_name]'s position": "CEO",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Asian",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "KQAL FM",
            "Parent Organization": "Winona State University",
            "Address": "175 W. Mark St",
            "City": "Winona,",
            "State": "MN",
            "Zip Code": "55987",
            "County": "Winona",
            "Main phone number": "507-457-2222",
            "Main fax number": "",
            "Organization email": "",
            "Organization website": "www.kqal.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Doug Westerman",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "DWesterman@winona.edu",
            "[contact_name]'s phone number": "507-457-2364",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "KQAL FM",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "Local arts, history, culture and music",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "Winona, MN ADI",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "La Raza 95.7 FM",
            "Parent Organization": "Santamaria Broadcasting Inc.",
            "Address": "3003 27th Ave S #400",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55406",
            "County": "Hennepin",
            "Main phone number": "612-354-3282",
            "Main fax number": "",
            "Organization email": "Maya@laraza1400.com",
            "Organization website": "www.laraza1400.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Maya Santamaria",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "Maya@laraza1400.com",
            "[contact_name]'s phone number": "651-231-1304",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "KMNV, KMNQ 95.7 FM AND 1400 & 1470 AM TRIPLE CAST",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Latino/Latinx",
            "Topics covered:": "La Raza in Minnesota's only Latino owned and operated Radio Station. With the hottest national and local programming, La Raza is Minnesota LatinX's choice for Spanish news, talk, music, and information relevant to the Latino Minnesota Community.",
            "Please list the languages your service offers:": "Spanish radio for the LatinX Community",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "200000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Minority Radio KPNP AM 1600",
            "Parent Organization": "",
            "Address": "6500 Brooklyn Blvd.  Suite 206",
            "City": "Brooklyn Center",
            "State": "MN",
            "Zip Code": "55429",
            "County": "Hennepin",
            "Main phone number": "763-585-1600",
            "Main fax number": "",
            "Organization email": "peter@kpnp1600.com",
            "Organization website": "www.kpnp1600.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Peter Phia Xiong",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Asian Media Access",
            "Parent Organization": "Radio Asia",
            "Address": "2418  Plymouth Ave N.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55411",
            "County": "Hennepin",
            "Main phone number": "612-376-7715",
            "Main fax number": "",
            "Organization email": "RadioASIA@amamedia.org",
            "Organization website": "www.radioasia.info",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Ange Hwang",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "amamedia@amamedia.org",
            "[contact_name]'s phone number": "612-376-7715",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "106.1 HD3 c/o Asian Media",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Asian",
            "Topics covered:": "Asian American and Pacific Islanders' issues, accomplishments and local events",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities",
            "Estimated circulation/audience size: ": "2500",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Somali American Radio KALY 101.7 FM",
            "Parent Organization": "",
            "Address": "2323 11th Ave #260",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "612-232-6094",
            "Main fax number": "",
            "Organization email": "kalyradio@gmail.com",
            "Organization website": "www.kalyradio.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Mahamed Cali",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "mcali@kalyradio.org",
            "[contact_name]'s phone number": "(612)-232-6094",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Association of Minnesota Public Educational Radio Stations (Ampers)",
            "Parent Organization": "",
            "Address": "1881 Munster Avenue",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55116",
            "County": "Ramsey",
            "Main phone number": "651-587-5550",
            "Main fax number": "651-286-3822",
            "Organization email": "jglaser@ampers.org",
            "Organization website": "www.ampers.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Joel Glaser",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "jglaser@ampers.org",
            "[contact_name]'s phone number": "(651)-587-5550",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "KAXE, KBEM(Jazz88), KBXE, KBFT, KFAI, KKWE, KMOJ, KMSU, KOJB, KRPR, KSRQ, KUMD, KUMM, KUOM (Radio K), KVSC, WGZS, WTIP",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "Ampers represents 18 independent community radio stations throughout Minnesota that primarily serve Native American, African American, new immigrant, and rural communities.",
            "Please list the languages your service offers:": "Spanish, Hmong, Somali, Oromo, Vietnamese, Tigrinya, Amharic, Ojibwe/Native American, African American, new immigrant, and rural communities.",
            "Please outline your coverage area (are of MN you serve):": "Satewide",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Hmong Radio 1600 AM",
            "Parent Organization": "",
            "Address": "",
            "City": "",
            "State": "",
            "Zip Code": "",
            "County": "",
            "Main phone number": "",
            "Main fax number": "",
            "Organization email": "",
            "Organization website": "",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Asian",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Hmong Radio AM 690 KHz",
            "Parent Organization": "",
            "Address": "1088 Payne Avenue.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55130",
            "County": "Ramsey",
            "Main phone number": "651-772-9999",
            "Main fax number": "",
            "Organization email": "",
            "Organization website": "",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Xeng Xiong",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "xeng690@yahoo.com",
            "[contact_name]'s phone number": "651-235-0388",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Asian",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "KRSM  Radio",
            "Parent Organization": "Pillsbury United Communities",
            "Address": "2323 11th Ave S.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "612-735-1825",
            "Main fax number": "",
            "Organization email": "contact@krsmradio.org",
            "Organization website": "www.krsmradio.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Brendan Kelly",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "contact@krsmradio.org",
            "[contact_name]'s phone number": "612-735-1825",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "98.9 FM -- KRSM-LP",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "Community radio, so it's a mix of what people bring to us.  Talk shows about politics and art and history and community organizing  and entrepreneurialism and more.  Plus tons of great music!",
            "Please list the languages your service offers:": "English, Spanish, Somali, Ojibwe, Hmong, and Haitian Creole.  10 hours of Indigenous-led programming each week.",
            "Please outline your coverage area (are of MN you serve):": "Minnetonka, Twincities metro .",
            "Estimated circulation/audience size: ": "1 million",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "KFAI - Fresh Air Community Radio 90.3 FM HD",
            "Parent Organization": "Fresh Air, Inc",
            "Address": "1808 Riverside Ave, #300",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55414",
            "County": "Hennepin",
            "Main phone number": "612-341-3144",
            "Main fax number": "",
            "Organization email": "hello@kfai.org",
            "Organization website": "www.kfai.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Mason Butler",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "mason@kfai.org",
            "[contact_name]'s phone number": "612-341-3144",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "90.3 FM",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "Entertainment, Arts, News, Information",
            "Please list the languages your service offers:": "English, Spanish, French, Oromo, Somali, Vietamese, Hmong, Amharic, Tigrinya",
            "Please outline your coverage area (are of MN you serve):": "Hennepin/Anoka/Ramsey",
            "Estimated circulation/audience size: ": "50000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Black America Urban Mass Media Group Cable Channels",
            "Parent Organization": "Urban Mass Media Group",
            "Address": "90 South 11th Street, Suite 276",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55403",
            "County": "Hennepin",
            "Main phone number": "612-341-2447",
            "Main fax number": "612-341-3912",
            "Organization email": "blackmusicamerica@gmail.com",
            "Organization website": "www.blackmusicamerica.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Pete Rhodes",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African American",
            "Topics covered:": "BMA Digital Channel delivers local and national entertainment, music, arts, news and marketing services through Comcast Cable (channel 937). BMA Networks also produce and distributes video, audio and web content highlighting business, entertainment, education and lifestyles through its parent company Urban Mass Media Group.",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Minneapolis and St. Paul and surrounding 13 counties.",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Oromo TV",
            "Parent Organization": "",
            "Address": "6900 Winetka Ave N",
            "City": "Brooklyn Park",
            "State": "MN",
            "Zip Code": "55445",
            "County": "Hennepin",
            "Main phone number": "763-464-3477",
            "Main fax number": "",
            "Organization email": "oromotv2001@gmail.com",
            "Organization website": "www.OromoTV.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Jelil Abdella",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "duskannoo@gmail.com",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Somali TV of Minnesota",
            "Parent Organization": "",
            "Address": "1901 Minnehaha Ave Suite 407",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "612-226-6692",
            "Main fax number": "",
            "Organization email": "",
            "Organization website": "www.somali5.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Siyad  Salah",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "siyadsalah@hotmail.com",
            "[contact_name]'s phone number": "612-226-6692",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "24/7",
            "TV network and channel": "Social media sites",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "Education, Health, Awerness , Politics, information. Our mission is to enrich lives and strengthen our community through the power of media.",
            "Please list the languages your service offers:": "Somali, English",
            "Please outline your coverage area (are of MN you serve):": "Statewide",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Asian Media Access",
            "Parent Organization": "",
            "Address": "2418 Plymouth Ave. N",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55411",
            "County": "Hennepin",
            "Main phone number": "612-376-7715",
            "Main fax number": "612-376-7730",
            "Organization email": "info@amamedia.org",
            "Organization website": "www.amamedia.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Ange Hwang",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "angehwang@amamedia.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Kang Vang",
            "[contact_name_2]'s position": "Director of Media Programming/Production",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Asian",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "3HmongTV",
            "Parent Organization": "Hmong Broadcasting Company Television (HBCTV)",
            "Address": "475 Etna Street  Suite 8",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55106",
            "County": "Ramsey",
            "Main phone number": "651-442-7698",
            "Main fax number": "",
            "Organization email": "mitchlee@hbctv.net",
            "Organization website": "www.hbctv.net",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Mitch Lee",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "mitchlee@hbctv.net",
            "[contact_name]'s phone number": "651-442-7698",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "Weekly",
            "TV network and channel": "3Hmong TV",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Asian",
            "Topics covered:": "Education, health, business, cultural programming",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "Statewide",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Viatnamese News",
            "Parent Organization": "Twin Cities Public  Television, Inc.",
            "Address": "172 East 4th St.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55101",
            "County": "Ramsey",
            "Main phone number": "651-222-1717",
            "Main fax number": "",
            "Organization email": "viewerservices@tpt.org",
            "Organization website": "www.tpt.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Shari Lamke",
            "[contact_name]'s position": "Director",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Asian",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Minneapolis Television Network (MTN)",
            "Parent Organization": "",
            "Address": "820 18th Ave NE",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55413",
            "County": "Hennepin",
            "Main phone number": "651-331-8575",
            "Main fax number": "651-331-8578",
            "Organization email": "michael@mtn.org",
            "Organization website": "www.mtn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Valerie Lockhart",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "651-331-8575",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "Channel 16, 17, 75",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "MTN serves the residents of Minneapolis with tools, programs, and activities to engage and connect diverse residents and institutions through the exchange of ideas, stories, and information. Channel 16: Connect offers community affairs-based programming about Minneapolis and its region, including news & information, public discussion, politics & government. Channel 17: Create is home to cultural and educational programming made by Minneapolis-based artists & creatives and by MTN's vibrant Youth Program. Channel 75: Inspire serves local communities of faith by offering a diverse array of religious and spiritual programming from around the region.",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities and its surrounding areas",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "St. Paul Neighborhood Network (SPNN)",
            "Parent Organization": "",
            "Address": "550 Vandalia St. STE 170",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55114",
            "County": "Ramsey",
            "Main phone number": "651-224-5153",
            "Main fax number": "651-298-8414",
            "Organization email": "info@spnn.org",
            "Organization website": "www.spnn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Martin Ludden",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "ludden@spnn.org",
            "[contact_name]'s phone number": "651-298-8900",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Twin Cities Public Television",
            "Parent Organization": "PBS",
            "Address": "172 East 4th Street",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55101",
            "County": "Ramsey",
            "Main phone number": "651-222-1717",
            "Main fax number": "",
            "Organization email": "tptnow@tpt.org",
            "Organization website": "www.tpt.org/tptnow                                                     www.tpt.org/ECHO",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Lillian McDonald",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "lmcdonald@tpt.org",
            "[contact_name]'s phone number": "651-229-1304",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "24/7/365",
            "TV network and channel": "Channel 2.5",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "TV Channel dedicated to distributing public health, safety and emergency response content for diverse communities. Builds on non-profit work initiated by Emergency Community Health and Outreach (ECHO), now 24/7 channel with Twin Cities Public Television.",
            "Please list the languages your service offers:": "English, Spanish, Hmong and Somali.",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities and surrounding areas (statewide potential if activated in partnership with government health/safety). One-Million Households - Metro Region",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Rochester Somali TV",
            "Parent Organization": "",
            "Address": "",
            "City": "",
            "State": "",
            "Zip Code": "",
            "County": "",
            "Main phone number": "507-271-7759",
            "Main fax number": "",
            "Organization email": "anhared@somalcrs.org",
            "Organization website": "",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Orange Oak",
            "Parent Organization": "Orange Oak",
            "Address": "1238 McAndrews road east",
            "City": "Burnsville",
            "State": "MN",
            "Zip Code": "55337",
            "County": "Dakota",
            "Main phone number": "612-352-0918",
            "Main fax number": "",
            "Organization email": "hajiasad123@gmail.com",
            "Organization website": "",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Haji Abu",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "hajiasad123@gmail.com",
            "[contact_name]'s phone number": "612-352-0618",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "Daily",
            "TV network and channel": "Geel Tv",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "Education",
            "Please list the languages your service offers:": "Somali, Swahili",
            "Please outline your coverage area (are of MN you serve):": "Central Minnesota",
            "Estimated circulation/audience size: ": "58000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "KREATIVE MINDZ TELEVISION (KMTV USA)",
            "Parent Organization": "KREATIVE MINDZ TELEVISION LIBERIA",
            "Address": "5609 Xylon Ave North Apartment 211",
            "City": "New Hope",
            "State": "MN",
            "Zip Code": "55428",
            "County": "Hennepin",
            "Main phone number": "612-806-5896",
            "Main fax number": "",
            "Organization email": "mcgeesmedia@gmail.com",
            "Organization website": "www.kmtvliberia.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Cyrus J. McGee",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "cyrusmcgee@gmail.com",
            "[contact_name]'s phone number": "612-806-5895",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "3pm cst and other times for special programs",
            "TV network and channel": "facebook kmtv liberia / youtube kmtv liberia",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African American,African (Immigrant)",
            "Topics covered:": "News, Interviews, Sports, Entertainment, Religious, Educational Etc.",
            "Please list the languages your service offers:": "English & The African (Liberian Community)",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "100,000 or more world wide.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Somali community resettlement services",
            "Parent Organization": "",
            "Address": "903 west center st suite 200",
            "City": "Rochester",
            "State": "MN",
            "Zip Code": "55904",
            "County": "Olmsted",
            "Main phone number": "507-384-3553",
            "Main fax number": "",
            "Organization email": "anhared@somalcrs.org",
            "Organization website": "www.scrs.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Abu farah",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "anhared@somalcts.org",
            "[contact_name]'s phone number": "507-384-3553",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "5 days per week",
            "TV network and channel": "Rstv l charter communication",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "Community services",
            "Please list the languages your service offers:": "Somali",
            "Please outline your coverage area (are of MN you serve):": "Statewide",
            "Estimated circulation/audience size: ": "20000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "TMZ Media Group LLC",
            "Parent Organization": "",
            "Address": "7420 Unity Ave N",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55443",
            "County": "Hennepin",
            "Main phone number": "763-807-7689",
            "Main fax number": "",
            "Organization email": "hussein.fadiga@gmail.com",
            "Organization website": "www.radioafrica.net",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Al-Hussein Youjay Fadiga",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Cyrus McGee",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "cyrusmcgee@gmail.com",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "The Liberian Journal",
            "Parent Organization": "",
            "Address": "7710 Brooklyn Blvd. Ste 206B",
            "City": "Brooklyn Park",
            "State": "MN",
            "Zip Code": "55443",
            "County": "Hennepin",
            "Main phone number": "612-388-4767",
            "Main fax number": "",
            "Organization email": "info@theliberianjournal.com",
            "Organization website": "www.theliberianjournal.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Abdullah Kiatamba",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "akiatamba@aisusa.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "We focus on producing, publishing, and sharing news information about events taking place in Liberia, Africa, and the world in general. Our news and information portfolio will include developments in the spheres of politics, economics, sports, health, entertainment, and many other areas of human interest.",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Mogadishu Times",
            "Parent Organization": "",
            "Address": "",
            "City": "",
            "State": "",
            "Zip Code": "",
            "County": "",
            "Main phone number": "",
            "Main fax number": "",
            "Organization email": "",
            "Organization website": "www.mogtimes.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Ilyas Maow",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "ilyaasmw@gmail.com",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African (Immigrant)",
            "Topics covered:": "",
            "Please list the languages your service offers:": "Somali, English",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "TheLongfellow/Nokomis Messenger",
            "Parent Organization": "TMC Publications CO",
            "Address": "5139 34th Avenue S. #17097",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55417",
            "County": "Hennepin",
            "Main phone number": "612-345-9998",
            "Main fax number": "",
            "Organization email": "",
            "Organization website": "",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Tesh Christensen",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "tesha@longfellownokomismessenger.com",
            "[contact_name]'s phone number": "612-345-9998",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "Print and Online",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Home delivery to 17,000 homes and an additional circulation of 4,000 at high-traffic business, church and school drop-off points",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Sun Post Newspapers",
            "Parent Organization": "",
            "Address": "33 Second St. N.E.",
            "City": "Osseo",
            "State": "MN",
            "Zip Code": "55369",
            "County": "Hennepin",
            "Main phone number": "763-425-3323",
            "Main fax number": "763-425-2945",
            "Organization email": "",
            "Organization website": "",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "(952)-392-6878",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Steele Dodge News",
            "Parent Organization": "",
            "Address": "",
            "City": "",
            "State": "",
            "Zip Code": "",
            "County": "",
            "Main phone number": "",
            "Main fax number": "",
            "Organization email": "dci@kmtel.com",
            "Organization website": "www.steeledodgenews.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Press",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Univision Minnesota",
            "Parent Organization": "Mediavista Minneapolis",
            "Address": "225 S 6th Street, Suite 3900",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55402",
            "County": "Hennepin",
            "Main phone number": "(612) 455-3966",
            "Main fax number": "",
            "Organization email": "oscar@mediavista.tv",
            "Organization website": "www.univisionminnesota.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "Facebook,Instagram,YouTube,Twitter",
            "Facebook link": "www.facebook.com/univisionminnesota",
            "Instagram Link": "www.instagram.com/univisionminnesota17/",
            "YouTube link": "www.instagram.com/univisionminnesota17/",
            "Twitter link": "https://twitter.com/Univisionmn17",
            "First Contact name": "Oscar Rodriguez",
            "[contact_name]'s position": "General Manager",
            "[contact_name]'s email": "oscar@mediavista.tv",
            "[contact_name]'s phone number": "(612) 455-3960 ext301",
            "Second Contact name": "Jason Riesgraf",
            "[contact_name_2]'s position": "Producer",
            "[contact_name_2]'s email": "jason@mediavista.tv",
            "[contact_name_2]'s phone number": "612-455-3966 ext304",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "24/7",
            "TV network and channel": "Univision Minnesota 17",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Caribbean,Latino/Latinx,Multicultural",
            "Topics covered:": "Only local Minnesota broadcast Hispanic TV station.  Affiliate to Univision network covering local issues that affect the Minnesota Latinx community.  News, entertainment, public affairs, etc.",
            "Please list the languages your service offers:": "Spanish",
            "Please outline your coverage area (are of MN you serve):": "Over the air signal covers entire Metro area, local signal in Comcast, Charter & Mediacom cable carriers covering area of St Cloud to Mankato.  Total coverage is approximately 75% of state.",
            "Estimated circulation/audience size: ": "175,000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "WUMN Univision Minnesota"
        },
        {
            "Name of Organization": "Keystone Interpreting Solutions",
            "Parent Organization": "",
            "Address": "1799 Hillcrest Ave",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55116",
            "County": "Ramsey",
            "Main phone number": "(651) 454-7275",
            "Main fax number": "",
            "Organization email": "",
            "Organization website": "covid.kisasl.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "Facebook",
            "Facebook link": "https://www.facebook.com/KeystoneInterpretingSolutions",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Estina Beldon",
            "[contact_name]'s position": "Media Coordiator",
            "[contact_name]'s email": "estina@kisasl.com",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Social Media",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural,People with disabilities",
            "Topics covered:": "COVID-19, Health, and Government ",
            "Please list the languages your service offers:": "American Sign Language",
            "Please outline your coverage area (are of MN you serve):": "All of MN",
            "Estimated circulation/audience size: ": "At least 5,000 monthly",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Oromia11",
            "Parent Organization": "",
            "Address": " 250 Second Ave South #106",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55401",
            "County": "Hennepin",
            "Main phone number": "",
            "Main fax number": "",
            "Organization email": "info@oromia11.org",
            "Organization website": "",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "Facebook,YouTube",
            "Facebook link": "https://www.facebook.com/0romia11",
            "Instagram Link": "",
            "YouTube link": " https://www.youtube.com/oromia11",
            "Twitter link": "",
            "First Contact name": "Safi Geleto",
            "[contact_name]'s position": "General Manager",
            "[contact_name]'s email": "safi.geleto@oromia11.org",
            "[contact_name]'s phone number": "(612) 978-4972",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "TV",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "African American,African (Immigrant),Multicultural",
            "Topics covered:": "",
            "Please list the languages your service offers:": "Oromo, Amharic and English. ",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "WFNU 94.1FM",
            "Parent Organization": "Frogtown Tuned-In, Inc.",
            "Address": "161 Rondo Avenue #1002",
            "City": "Saint Paul",
            "State": "MN",
            "Zip Code": "55103",
            "County": "Ramsey",
            "Main phone number": "(612) 600-1556",
            "Main fax number": "",
            "Organization email": "stationmanager@wfnu.org",
            "Organization website": "wfnu.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Philip M Gracia",
            "[contact_name]'s position": "Co-Director",
            "[contact_name]'s email": "Philip@frogtowntunedin.org",
            "[contact_name]'s phone number": "(612) 600-1556",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Radio",
            "Radio call sign and frequency": "WFNU 94.1FM",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "Multicultural",
            "Topics covered:": "Music, sports and talk",
            "Please list the languages your service offers:": "English ",
            "Please outline your coverage area (are of MN you serve):": "St. Paul, MN  Frogtown, Rondo and Midway",
            "Estimated circulation/audience size: ": "25,000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Frogtown, Rondo, Midway"
        },
        {
            "Name of Organization": "Native Roots Radio - AM950",
            "Parent Organization": "JR Broadcasting LLC",
            "Address": "11320 Valley View Rd.",
            "City": "Eden Prairie",
            "State": "MN",
            "Zip Code": "55344",
            "County": "Hennepin",
            "Main phone number": "(952) 946-8885",
            "Main fax number": "",
            "Organization email": "Chad@am950radio.com",
            "Organization website": "https://www.am950radio.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "(952) 946-8885",
            "Supplemental Organization Website ": "https://www.am950radio.com/events/native-roots-radio/",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "Chad Larson",
            "[contact_name]'s position": "President",
            "[contact_name]'s email": "Chad@am950radio.com",
            "[contact_name]'s phone number": "(952) 693-6032",
            "Second Contact name": "Robert Pilot",
            "[contact_name_2]'s position": "Host",
            "[contact_name_2]'s email": "am950nativerootsradio@gmail.com",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "Social Media",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "American Indian,LGBTQIA",
            "Topics covered:": "Native American issues and news.",
            "Please list the languages your service offers:": "English",
            "Please outline your coverage area (are of MN you serve):": "Twin Cities over the air and entire state with streaming.",
            "Estimated circulation/audience size: ": "100,00 - 200,000",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Radio, Media, Streaming, Podcast, Live Video, Symposiums, Marketing"
        },
        {
            "Name of Organization": "St. Cloud Somali Community Radio",
            "Parent Organization": "Laarri Media Group",
            "Address": "4000 Clearwater Road 112",
            "City": "St. Cloud",
            "State": "MN",
            "Zip Code": "56301",
            "County": "",
            "Main phone number": "612-232-3866 ",
            "Main fax number": "",
            "Organization email": "stsomaliradio@gmail.com",
            "Organization website": "",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "XIDIG TV",
            "Parent Organization": "",
            "Address": "333 West Division Street Suite 112A",
            "City": "St. Cloud",
            "State": "MN",
            "Zip Code": "56301",
            "County": "",
            "Main phone number": "320-233-9272",
            "Main fax number": "",
            "Organization email": "mohamed@xidigtv.com",
            "Organization website": "https://xidigtv.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Social Media Platform": "",
            "Facebook link": "",
            "Instagram Link": "",
            "YouTube link": "",
            "Twitter link": "",
            "First Contact name": "",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Type of Media": "",
            "Radio call sign and frequency": "",
            "Dates and times of broadcast": "",
            "TV network and channel": "",
            "Press format": "",
            "Publication dates for print media": "",
            "Publication dates for online media": "",
            "Target audience": "",
            "Topics covered:": "",
            "Please list the languages your service offers:": "",
            "Please outline your coverage area (are of MN you serve):": "",
            "Estimated circulation/audience size: ": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        }
]

export default dmData;